module.exports = __webpack_public_path__ + "img/template-dne-market-02.84a0a5df.jpg";